export const formatContestantsData = (contestant) => ({
  id: contestant.Id || contestant.id,
  name: `${contestant.FirstName || contestant.firstName || ""} ${
    contestant.LastName || contestant.lastName || ""
  }`,
  photo: contestant.Photo || contestant.photo,
  votes: contestant.Votes || contestant.votes || 0,
  votingBucket: contestant.VotingBuckets || [],
});
